export const CATEGORY_ALL_COVER_IMAGE_URL =
  'https://shestrong.sfo2.cdn.digitaloceanspaces.com/cookbook/covers/cat-all.jpg';
export const CATEGORY_ALL_NAME = 'cookbook.mealCategoryThumb.allMealsTitle';
